import { IMPERSONATION_BANNER_COOKIE } from "@punchup/data/supabase/impersonation";

/**
 * globals.css moves fixed top chrome down by --app-banner-height while <html>
 * carries this attribute.
 */
export const APP_BANNER_ATTRIBUTE = "data-app-banner";

/**
 * Sets <html data-app-banner> before first paint when the login-as banner
 * cookie exists, so the header does not jump down after hydration. The root
 * layout inlines it in <head>; ImpersonationBanner corrects the attribute once
 * it knows whether it shows. A plain module, not "use client": the layout is a
 * server component and needs the string itself.
 */
export const APP_BANNER_HEAD_SCRIPT = `document.cookie.split("; ").some(function(c){return c.indexOf(${JSON.stringify(
  `${IMPERSONATION_BANNER_COOKIE}=`
)})===0})&&document.documentElement.setAttribute(${JSON.stringify(
  APP_BANNER_ATTRIBUTE
)},"")`;
